import { html, LitElement, css } from 'lit';
import { property } from 'lit/decorators.js';
import { TWStyles } from '../styles/tw.js';

export class IxManualLogoutDialog extends LitElement {
  static styles = [
    TWStyles,
    css`
      @media only screen and (min-width: 601px) {
        [slot='content'] {
          width: 560px;
        }

        [slot='content'] {
          color: var(--clr-on-surface-variant, #092241b3);
        }
      }
    `,
  ];

  @property({ type: Boolean }) open = false;

  private _handleClosed() {
    this.dispatchEvent(new Event('closed'));
  }

  render() {
    return html`
      <ix-dialog ?open=${this.open} @closed=${this._handleClosed}>
        <h1 slot="headline" class="dlr-text-heading">Attention</h1>
        <div slot="content" class="dlr-text-default">
          <p>You will be logged out of all Digital Realty Portals.</p>
        </div>
        <div slot="actions">
          <ix-button
            @click=${() => {
              window.location.href = '/logout';
            }}
            appearance="text"
          >
            Log out now
          </ix-button>
          <ix-button @click=${() => (this.open = false)} appearance="text">
            Keep me signed in
          </ix-button>
        </div>
      </ix-dialog>
    `;
  }
}

window.customElements.define('ix-manual-logout-dialog', IxManualLogoutDialog);
